export default __webpack_public_path__ + "static/media/pdf.b9056319.svg";